module.exports = __webpack_public_path__ + "b9f2ce90d48a3a0c8a98d72c5679a5d6.svg";